import React from "react";
import "./FeatureCard.scss";

import FeatureCardBottomLight from "../../../assets/images/feature-card-bottom-light.svg";

export default function FeatureCard({ children, className = "" }) {
	return (
		<div className={`feature-card ${className}`}>
            <div className="feature-card-top-light"></div>
            <img className="feature-card-bottom-light" src={FeatureCardBottomLight} alt="Feature Card Bottom Light" />

			<div className="feature-card-content">{children}</div>
		</div>
	);
}
